import { JORNAYA_DISCLOSURE_ID } from '../../../Helpers/jornaya';
import convertMarkdownLinks from '../../../Helpers/MdownConverter';

const cleanPhoneNumber = (phone = '') => phone?.replace(/[^\d]/g, '');
const updateSubmitButtonLabel = (text, label = 'Next Step') => text?.replace(/submit_button_label/g, label);

const defaultDisclosureText = () => {
    if (window?.disclosure) {
        return window.disclosure;
    }
    const phoneTemplateText = 'phone_number';
    const submitButtonText = 'submit_button_label';
    return [
        `By entering my phone number and/or email, and clicking "${submitButtonText}", I agree to receive recurring marketing emails, calls (including artificial or prerecorded voice), and texts at the number I provided to Tivly and one or more of our`,
        '[insurance-related partners](/insurance-related-partners)',
        'via an autodialer, even if my number is on a Do Not Call list. Consent is not a condition of purchase; opt-out anytime. Msg & data rates may apply. View our',
        '[Terms and Conditions](/terms-and-conditions)',
        'for details. If you have questions or to opt-out, please call us at',
        `${phoneTemplateText}. `,
        `By clicking the "${submitButtonText}" button, I agree to the`,
        '[Privacy Policy](/privacy-policy)',
        'and',
        '[Terms and Conditions](/terms-and-conditions).',
    ].join(' ');
};

const callbackDisclosureText = () => {
    const phoneTemplateText = 'phone_number';
    const submitButtonText = 'submit_button_label';

    return [
        `By entering my phone number and/or email, and clicking "${submitButtonText}", I agree to receive recurring marketing emails, calls (including artificial or prerecorded voice), and texts at the number I provided to Tivly and our`,
        '[insurance related partners](/insurance-related-partners)',
        'via an autodialer, even if my number is on a Do Not Call list. Consent is not a condition of purchase; opt-out anytime. Msg & data rates may apply. View our',
        '[Terms and Conditions](/terms-and-conditions)',
        'for details. If you have questions or to opt-out, please call us at',
        `${phoneTemplateText}. `,
        `By clicking the "${submitButtonText}" button, I agree to the`,
        '[Privacy Policy](/privacy-policy)',
        'and',
        '[Terms and Conditions](/terms-and-conditions).',
    ].join(' ');
};

const DisclosureText = ({ disclosureText, submitButtonText, callbackDisclosure = false }) => {
    const phone = window?.lead_phone || '';

    let dt = disclosureText || defaultDisclosureText();

    if (callbackDisclosure) {
        dt = callbackDisclosureText();
    }

    // Replace phone_number with the phone number value
    dt = dt.replace(/phone_number/g, `[${phone}](tel:${cleanPhoneNumber(phone)})`);
    dt = updateSubmitButtonLabel(dt, submitButtonText);
    return (
        <label className="disclosure-text">
            <input type="hidden" id={JORNAYA_DISCLOSURE_ID} />
            <span
                dangerouslySetInnerHTML={{
                    __html: convertMarkdownLinks(dt, { target: '_blank', rel: 'noopener' }, true),
                }}
            />
        </label>
    );
};

export default DisclosureText;
